export default "__VITE_ASSET__DROHNeyT__"